import { Instance, types } from "mobx-state-tree";

export enum AsyncOpState {
  Untouched = "Untouched",
  Changed = "Changed", // before
  Saving = "Saving",
  Success = "Success",
  Error = "Error",
}


const asyncOpStateEnumType = types.enumeration([
  AsyncOpState.Untouched,
  AsyncOpState.Changed,
  AsyncOpState.Saving,
  AsyncOpState.Success,
  AsyncOpState.Error,
]);

export enum SaveCompStep {
  CreatingScene = "CreatingScene",
  Rendering = "Rendering",
  UploadingImages = "UploadingImages",
  UploadingVideos = "UploadingVideos",
  UploadingAudio = "UploadingAudio",
  UploadingFonts = "UploadingFonts",
  UploadingJson = "UploadingJson",
  Idle = "Idle"
}

const saveCompProcessStepEnumType = types.enumeration([
  SaveCompStep.CreatingScene,
  SaveCompStep.Rendering,
  SaveCompStep.UploadingImages,
  SaveCompStep.UploadingVideos,
  SaveCompStep.UploadingAudio,
  SaveCompStep.UploadingFonts,
  SaveCompStep.UploadingJson,
  SaveCompStep.Idle
]);


export const INITIAL_ASYNC_OP_STATE = AsyncOpState.Changed; // todo: changes to untouched after fixing settings form UI behaviour
export const asyncOpStateType = types.optional(
  asyncOpStateEnumType,
  INITIAL_ASYNC_OP_STATE
);

export const INITIAL_SAVE_COMP_STEP = SaveCompStep.Idle; // todo: changes to untouched after fixing settings form UI behaviour
export const saveCompProcessStepType = types.optional(
  saveCompProcessStepEnumType,
  INITIAL_SAVE_COMP_STEP
);

export function updateAsyncStatus(self: Instance<any>, key: string) {
  return (newStatus: AsyncOpState) => {
    self[key] = newStatus;
  };
}

export function updateSaveCompStep(self: Instance<any>, key: string) {
  return (newStatus: SaveCompStep) => {
    self[key] = newStatus;
  };
}
